{/* Auto-generated icon - do not edit */}
import React from 'react'

interface Send2IconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const Send2Icon = React.forwardRef<SVGSVGElement, Send2IconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 116 110"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M1.32922 50.3838C1.5056 39.0603 1.72398 24.1133 1.99339 9.1708C2.04507 7.62646 2.238 6.09019 2.5697 4.58118C3.37276 0.654175 5.32582 -0.401112 9.01357 1.2353C13.8591 3.38483 18.6019 5.75436 23.4409 7.91492C43.2946 16.7796 63.0972 25.7665 83.0726 34.3536C90.7569 37.6575 98.8476 40.0128 106.75 42.8074C108.101 43.285 109.464 43.7483 110.779 44.3093C111.554 44.6153 112.251 45.0944 112.814 45.7103C113.377 46.3262 113.793 47.0628 114.03 47.8637C114.191 48.3904 114.288 48.9429 114.497 49.4489C116.317 53.8386 116.075 55.1676 111.963 57.6018C101.324 63.9054 90.66 70.1761 79.8649 76.2061C61.33 86.5105 42.2796 95.8566 22.789 104.208C18.2401 106.168 13.421 107.504 8.71832 109.098C8.08892 109.307 7.43309 109.426 6.7704 109.452C4.64872 109.537 3.68544 108.854 3.39342 106.711C2.81393 103.117 2.42961 99.4931 2.24213 95.8566C1.86547 81.9119 1.66389 67.9606 1.32922 50.3838ZM12.1018 100.402C41.2998 87.3517 69.7242 72.6304 97.2344 56.3116C94.5474 56.3116 92.5129 56.2107 90.4914 56.3304C84.5398 56.6817 78.5934 57.1165 72.6451 57.5254C64.273 58.1007 55.9071 58.7937 47.5276 59.233C35.8493 59.8451 24.1903 61.3639 12.4597 60.2076C12.0217 60.2474 11.5898 60.337 11.1721 60.4749C11.4764 73.5894 11.782 86.6878 12.1018 100.404V100.402ZM11.1469 52.5897C12.6089 52.6739 13.6976 52.8238 14.7797 52.7837C21.0647 52.5508 27.3619 52.4537 33.6294 51.9743C48.927 50.8031 64.2103 49.4508 79.4998 48.1657C83.1824 47.8564 86.8611 47.5264 90.5418 47.2068C63.1075 36.2171 36.8688 22.9214 9.79337 10.5671C9.98009 24.8981 10.4879 38.6566 11.1469 52.5923V52.5897Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="115" height="110" fill={color} transform="translate(0.777344)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

Send2Icon.displayName = 'Send2Icon'
